import { Route } from 'react-router'

import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as ClassificationActions from 'app/modules/classification/actions'
import * as ClassificationSelectors from 'app/modules/classification/selectors'

import Playbook from './components/Playbook'
import Goal from './components/Goal'
import Sequence from './components/Sequence'
import SequenceOptions from './components/SequenceOptions'
import SequencePreview from './components/SequencePreview'
import Review from './components/Review'
import WelcomeMessage from './components/WelcomeMessage'
import TargetedMessage from './components/TargetedMessage'
import TakeoverMessage from './components/TakeoverMessage'
import EmailCaptureMessage from './components/EmailCaptureMessage'
import EmailMessage from './components/EmailMessage'
import EmailMessagePreview from './components/EmailMessagePreview'
import TargetingAudience from './components/TargetingAudience'
import TargetingDisplay from './components/TargetingDisplay'
import TargetingDisplayWhen from './components/TargetingDisplayWhen'
import TargetingAdvanced from './components/TargetingAdvanced'
import TargetingExcludes from './components/TargetingExcludes'
import DriftLink from './components/DriftLink'
import SignatureEditor from './components/SignatureEditor'
import SignaturePreview from './components/SignaturePreview'

export const Routes = store => (
  <Route
    path="/playbooks/:playbookId"
    onEnter={({ params: { playbookId }}) => {
      const state = store.getState()
      if (!ClassificationSelectors.isLoaded(state)) {
        store.dispatch(ClassificationActions.fetchClassifications())
      }

      const draft = PlaybookSelectors.draft(state)
      const draftId = PlaybookSelectors.draftId(state)
      if (!draft || `${draftId}` !== playbookId) {
        store.dispatch(PlaybookActions.fetchPlaybook({ id: playbookId }))
      }
    }}
  >
    <Route
      path="edit"
      component={Playbook}
      onEnter={() => {
        const cardContainer = document.getElementsByClassName('subcontent')
        cardContainer.length ? (cardContainer[0].scrollTop = 0) : null
      }}
    >
      <Route path="goal">
        <Route
          path=":goalId"
          component={Goal}
          onEnter={({ params: { goalId }}) => {
            const state = store.getState()
            const goal = PlaybookSelectors.currentGoal(state)
            if (goal.id !== goalId) {
              store.dispatch(PlaybookActions.setCurrentGoalId(goalId))
            }
          }}
        />
      </Route>
      <Route path="sequence" component={Sequence} />
      <Route path="sequence/preview" component={SequencePreview} />
      <Route path="sequence/options" component={SequenceOptions} />
      <Route path="message">
        <Route path="welcome" component={WelcomeMessage} />
        <Route path="targeted" component={TargetedMessage} />
        <Route path="takeover" component={TakeoverMessage} />
        <Route path="capture" component={EmailCaptureMessage} />
        <Route path="email" component={EmailMessage} />
        <Route path="email-preview" component={EmailMessagePreview} />
        <Route path="signature" component={SignatureEditor} />
        <Route path="signature-preview" component={SignaturePreview} />
      </Route>
      <Route path="targeting">
        <Route path="build-segment" render={({ location, router }) => router.push({ pathname: location.pathname.split('/').slice(0, -1).concat(['audience']).join('/') })} />
        <Route path="audience" component={TargetingAudience} />
        <Route path="display" component={TargetingDisplay} />
        <Route path="displaywhen" component={TargetingDisplayWhen} />
        <Route path="driftlink" component={DriftLink} />
        <Route path="advanced" component={TargetingAdvanced} />
        <Route path="exclude" component={TargetingExcludes} />
      </Route>
      <Route path="review" component={Review} />
    </Route>
  </Route>
)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/routes.js